import React from 'react';
import {
  Image,
  Box,
  Text,
  Container
} from '@chakra-ui/react';

import BioWithRightMedia from '../../components/sections/biowithrightmedia';

import EVPMountainHardwear from '../../components/ui/ourcompany/leadership/TROY_SICOTTE_MHW_HEADSHOT-scaled.jpeg'
export default function MountainHardwearTabPanel() {
  return (
    <Box>
      <Container maxW='6xl' my={14} className='flow'>
        <BioWithRightMedia
          title={'TROY SICOTTE'}
          subTitle={'PRESIDENT, MOUNTAIN HARDWEAR'}
          bio={
              <Text>
                Troy Sicotte joined Mountain Hardwear in 2018 as Vice President of
                Sales and was named President of the Mountain Hardwear brand in
                September 2021. Prior to joining Mountain Hardwear, Mr. Sicotte
                served as Global Director of Sales at 034Motorsport. He held
                several leadership roles at The North Face, including Director of
                Sales: Footwear and Director of Sales: National Outdoor & Sporting
                Goods, and began his career at Birkenstock.
              </Text>
          }
          media={
            <Image
              borderRadius={10}
              src={EVPMountainHardwear}
            />
          }
        />
      </Container>
    </Box>
  );
}
